import { getRequest, postRequest } from 'utils/http'

export const createMyLeadershipProfileApi = ({
  provider,
  transcriptIds
}) =>
  postRequest('/leadership-profiles', {
    provider,
    transcriptIds
  })

export const createUserLeadershipProfileApi = ({
  userId,
  provider,
  transcriptIds
}) =>
  postRequest(`/leadership-profiles/user/${userId}`, {
    provider,
    transcriptIds
  })

export const getLeadershipProfileApi = id =>
  getRequest(`/leadership-profiles/${id}`)

export const listMyLeadershipProfilesApi = () =>
  getRequest('/leadership-profiles')

export const listUserLeadershipProfilesApi = userId =>
  getRequest(`/leadership-profiles/user/${userId}`)
